module.exports = __webpack_public_path__ + "img/Edit.cb723cda.svg";